// extracted by mini-css-extract-plugin
export default {"searchInput":"fio_searchInput__WQYy1"};